import { IDropDownItem } from '@portal/marketplace/templates';
export interface IVersionsSelector {
  createVersionsDropDown(...args): void;
  versionSelected(selectedVersion: IDropDownItem): void;
}
